import React from 'react'
import styled from 'styled-components'
import SearchIcon from '@mui/icons-material/Search';
import Cartas from '../../components/cartas/Cartas.jsx'
import { useState, useEffect } from 'react';
import { collection, getDocs, query, where, addDoc, serverTimestamp,orderBy,startAt,endAt } from 'firebase/firestore';
import { db } from '../../firebase-config';


//#region CSS
const Navbar = styled.div`
width: 0;

`

const Wrapper = styled.div`
display: flex;
align-items: right;
justify-content: right;
width: 100%;
margin-right:  100px;
`


const Search = styled.div`
  height: 35px;
  display: flex;
  margin: 10px 40px;
  
  .item{
    color: #c5c5c5;
    display: flex;
    height: 34px;
    width: 27px;
  }

input{
  border-radius: 11px;
  line-height: 25px;
  border: 0;
  background-color: #eee;
  outline: none;
  width: 200px;
  padding: 7px;
  font-weight: 500;

  &::placeholder{
    font-size: 15px;
    padding: 5px;
  }
}
`
//#endregion

function NavBar() {

  const [filter, setFilter] = useState("")
  const [events, setEvents] = useState([]);

  // Get Events
  useEffect(()=>{
    getEvents()
  },
  []);

  async function getEvents() {
    let list = []

    try{

      const querySnapshot = await getDocs(collection(db, "events"));
      querySnapshot.docs.forEach((doc) => {
        list.push({ id: doc.id, ...doc.data() })
      });
      setEvents(list);
      
    }catch(err){
    }
  }

  // Filter Events
  const searchText = async (item) => {    

    const value = item.target.value;
    console.log(value);
    if(value.length > 0){

      const filteredEvents = events.filter((e) => {
        return `${e.name}`
          .toLowerCase()
          .includes(item.target.value.toLowerCase().replace(' ', '-'));
      });

      setEvents(filteredEvents)
    }else{
    getEvents()
    }

  }

    return (
      <>
        <Navbar>
          <Wrapper>
            <Search >
              <SearchIcon className='item' />
              <input type="text" name="input" placeholder='Buscar...' defaultValue={filter} onChange={(e) => searchText(e)} />
              <div>
              </div>
            </Search>
          </Wrapper>
        </Navbar>
      </>
    )
  }

  export default NavBar